import {userConstants} from '../../_constants';

export function listTypeDelivery(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_LIST_TYPE_DELIVERY_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_LIST_TYPE_DELIVERY_SUCCESS:
      return {
        loading: false,
        // typeDelivery: action.data,
        ...action.data,
      };
    case userConstants.GET_LIST_TYPE_DELIVERY_FAILURE:
      return {
        error: action.error,
      };

    default:
      return state;
  }
}
